import clsx from "clsx";

import { Scroll } from "@/components/displays";
import { formatCurrency } from "@/utils/currency";

import { CartAddLink } from "../CartAddLink";
import styles from "./MobileFloatPurchaseBars.module.scss";
import { CartAddedNotification } from "../CartAddedNotification";

export interface MobileFloatPurchaseBarsProps {
  showCTAButton: boolean;
  subscriptionEnabled?: boolean;
  showSPNotification: boolean;
  quantity?: number | null;
  productVariantTitle: string;
  productMeal?: string;
  firstSubscriptionSubtotal: number;
  normalSubtotal: number;
  freeShippingPrice?: number;
  handleCloseSPNotification: () => void;
  cartAddLinkTitle: string;
  onClickCartAddLink: () => void;
  cartAddLinkDisabled?: boolean;
}

export function MobileFloatPurchaseBars({
  showCTAButton,
  subscriptionEnabled,
  showSPNotification,
  quantity,
  productVariantTitle,
  productMeal = "",
  firstSubscriptionSubtotal,
  normalSubtotal,
  freeShippingPrice,
  handleCloseSPNotification,
  cartAddLinkTitle,
  onClickCartAddLink,
  cartAddLinkDisabled,
}: MobileFloatPurchaseBarsProps) {
  return (
    <div>
      {/* フローティングしている数量選択フォームへのリンクボタン */}
      {showCTAButton && (
        <Scroll className={clsx(styles.selectQuantityScroll, "clear__pc")} to="productAnchor">
          種類・数量を選ぶ
        </Scroll>
      )}

      {/* フローティングしてるカート追加ボックス */}
      {showCTAButton && !showSPNotification && (
        <div className={clsx(styles.oneClick, "clear__pc")}>
          <div className="text__left">
            <span className="text__s">
              <span className={styles.oneClickIfSubscription}>
                {subscriptionEnabled ? "継続コース" : "一回のみお届け"}：{productVariantTitle}
                {quantity != null && `${quantity}${productMeal}`}
              </span>
            </span>
            <p className="text__m text__bold">
              {formatCurrency(subscriptionEnabled ? firstSubscriptionSubtotal : normalSubtotal)}
            </p>
          </div>
          <CartAddLink
            title={cartAddLinkTitle}
            onClick={onClickCartAddLink}
            disabled={cartAddLinkDisabled}
          />
        </div>
      )}

      {/* PC版でも表示 */}
      {showSPNotification && (
        <div className={clsx(styles.floatingCartNotification)}>
          <CartAddedNotification
            freeShippingPrice={freeShippingPrice ?? 0}
            onLinkClick={handleCloseSPNotification}
          />
        </div>
      )}
    </div>
  );
}
